import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import AttendanceListing from 'views/admin/attendance/AttendanceListing'
import PendingAttendancePage from 'views/admin/attendance/PendingAttendancePage'

const Attendance = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={`${path}/pending`}>
        <PendingAttendancePage />
      </Route>
      <Route exact path={path}>
        <AttendanceListing />
      </Route>
    </Switch>
  )
}

export default Attendance
